import analytics from "../../common/analytics/analytics";

const pageViewDataPush = (
  aaId: string,
  cas: string,
  ssoId: string,
  userType: string
) => {
  analytics.push({
    event: {
      action: "",
      category: "",
      label: "",
      name: "search-pageview",
      section: "",
      value: "",
    },
    pageInfo: {
      pagePath: "/search/SavedSearches",
      pageTitle: "",
      previousPage: "",
    },
    user: {
      aaId, //customerAccountUserID|peep_analyticsID
      authenticated: "is-logged-in",
      cardcolour: "", //if available from buyer API
      cas, //sourceaccount_Id
      ssoId, //SSOID|sub
      userId: "",
      userType, //private|TradeUser|Buyer
    },
  });
};

export default pageViewDataPush;
